<template>
  <div class="list">
    <div class="top">
      <div class="left">
        <img src="@/assets/images/left-3.png" alt="">
      </div>
      <div class="right">
        <img src="@/assets/images/right-3.png" alt="">
      </div>
    </div>
    <p class="top_title"><span v-text="data.productLineName"></span>生产状态看板</p>
    <div class="top_title text">
      <span style="text-align:left;">第<span v-text="data.weekOfYear"></span>周</span>
      <span><span v-text="data.englishProductLineName"></span> Assembly Status Kanban</span>
      <span style="text-align:right;" v-text="data.now"></span>
    </div>
    <div class="table">
      <el-table :data="data.tableData" border style="width: 100%"
                header-row-class-name="table_header_class">
        <el-table-column prop="brand" width="150px">
          <template #header>
            <p>品牌</p>
            <p>Brand</p>
          </template>
        </el-table-column>
        <el-table-column width="200px">
          <template #header>
            <p>型号</p>
            <p>Type</p>
          </template>
          <template #default="scope">
            <div style="text-align: center">
              <span> {{ scope.row.productLineName }}<br/>{{ scope.row.foreignName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYield" width="100px">
          <template #header>
            <p>排产量</p>
            <p>Output</p>
          </template>
        </el-table-column>
        <el-table-column prop="completeNumber" width="100px">
          <template #header>
            <p>完成量</p>
            <p>Compl</p>
          </template>
        </el-table-column>
        <el-table-column prop="beat" width="150px">
          <template #header>
            <p>节拍时间</p>
            <p>Takt time</p>
          </template>
        </el-table-column>
        <el-table-column prop="remaindTime" width="150px">
          <template #header>
            <p>剩余时间</p>
            <p>Remain</p>
          </template>
        </el-table-column>
        <!-- 工位状态 -->
        <el-table-column class-name="status">
          <template #header>
            <p>工位状态</p>
            <p>Station Status</p>
          </template>
          <template #default="scope">
            <div class="status_box" style="text-align: center;">
              <div :style="{width: (100 / scope.row.stationList.length) + '%'}" :class="['status_item', statusClassName(data.lineStop ? 4 : item.stationState), ((item.scheduleNumber && item.scheduleNumber.length === 8) ? 'threeLinesHeight' : 'oneLineHeight')]"
                    v-for="item in scope.row.stationList" :key="item.id">
                <p v-if="item.scheduleNumber && item.scheduleNumber.length === 8">{{ item.number ? item.number.substr(0, 4) : '' }} <br/>
                <span style="font-size: 16px; color: black;">
                  {{ item.scheduleNumber ? item.scheduleNumber.substr(0, 4) : '' }} <br/>{{ item.scheduleNumber ? item.scheduleNumber.substr(4, 4) : '' }} </span></p>
                <p v-if="item.scheduleNumber === null || item.scheduleNumber.length !== 8">
                  {{ item.number ? item.number.substr(0, 4) : '' }}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, computed, nextTick } from 'vue'
import axios from '@/utils/http'

const data = reactive({
  tableData: [],
  lineCode: 'HWT',
  time: null,
  weekOfYear: 1,
  productLineName: '',
  englishProductLineName: '',
  now: '',
  lineStop: false,
  itemWidth: '8.33%',
  showType: '白色标准'
})

onMounted(() => {
  getParam()
  /* 初始化时请求 */
  fetchListInit()
  // eslint-disable-next-line no-undef
  if (webConfig.time) {
    data.time = setInterval(() => {
      fetchListInit()
      // eslint-disable-next-line no-undef
    }, 10000)
  }
})

const getParam = () => {
  const url = window.location.href
  const dzUrl = url.split('#')[0]
  const cs = dzUrl.split('?')[1]
  data.lineCode = cs.split('=')[1]
}
/* 请求数据并计算工位更新视图 */
const fetchListInit = () => {
  axios.get('/api/board/getLineInfo/' + data.lineCode).then(res => {
    if (res.code === 200) {
      console.log(res.data)
      if (res.data.showType !== data.showType) {
        window.location.reload()
      }
      data.weekOfYear = res.data.weekOfYear
      data.productLineName = res.data.productionLineName
      data.englishProductLineName = res.data.englishProductionLineName
      data.now = res.data.now
      data.lineStop = res.data.stopped
      const arr = [{
        id: res.data.id,
        number: res.data.number,
        name: res.data.productionLineName,
        brand: res.data.brand,
        productLineName: res.data.productionLineName,
        foreignName: res.data.englishProductionLineName,
        workshopId: 0,
        rouseTime: '0:15',
        beat: res.data.beatTime,
        planYield: res.data.planNumber,
        completeNumber: res.data.completeNumber,
        remaindTime: res.data.timeRemain,
        pdi: '78567463474',
        pending: '4534534523.45',
        isDel: 0,
        createUser: 'admin',
        createTime: '2022-04-28 16:48:49',
        updateUser: 'admin',
        updateTime: '2022-04-28 16:48:49',
        workshopName: null,
        stationList: res.data.stationList
      }]
      data.tableData = arr
    }
  })
}

const statusClassName = (value) => {
  switch (value) {
    case 0:
      return 'error' // 红色
    case 1:
      return 'yellow' // 黄色 超时
    case 2:
      return 'green' // 深绿
    case 3:
      return 'darkGreen' // 正常 绿色
    case 4:
      return 'gray' // 灰色 停线
  }
}
const getFirstElementChild = (element) => {
  if (element.firstElementChild) {
    return element.firstElementChild
  } else {
    let node = element.firstChild
    while (node && node.nodeType !== 1) {
      node = node.nextSibling
    }
    return node
  }
}

/* 合并品牌 */
const arraySpanMethod = ({
  row,
  column,
  rowIndex,
  columnIndex
}) => {
  /* 判断是否为第一列 */
  if (columnIndex === 0) {
    if (row.col) {
      return {
        rowspan: row.col,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      }
    }
  }
}
</script>

<style lang="scss">
.list {
  .error {
    background-color: red;
    color: #fff;
  }
  .darkGreen {
    background-color: #027639;
    color: #fff;
  }
  .yellow {
    background-color: rgba(201, 201, 35, 0.822);
    color: #333;
  }
  .green {
    background-color: rgb(26, 255, 0);
    color: #fff;
  }
  .gray {
    background-color: darkgray;
    color: #fff;
  }
  .threeLinesHeight {
    line-height: 24px;
  }
  .oneLineHeight {
    line-height: 74px;
  }
  .el-table th.el-table__cell > .cell {
    text-align: center;
  }

  .el-table .el-table__cell {
    text-align: center;
  }

  .el-table__inner-wrapper::before, .el-table--border .el-table__cell {
    border-color: #41535d;
  }

  .el-table__inner-wrapper::before {
    height: 0;
  }

  .table_header_class {
    .el-table__cell {
      color: #fff;
      font-weight: 700;
      font-size: 18px;
      background-color: #41535d;
    }
  }

  .el-table--border::before {
    background-color: #41535d;
  }

  .el-table--border::before {
    left: 1px;
  }
}
</style>

<style lang='scss'>
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #41535d !important;
  height: 80px;
}
.el-scrollbar {
  font-size: 18px;
  font-weight: 700;
}
</style>

<style lang="scss" scoped>
.list {
  padding: 15px;
  overflow: hidden;
  .top {
    .left, .right {
      display: inline-block;
      height: 107px;

      img {
        height: 100%;
      }
    }

    .left {
      transform: translateX(-40px);
    }

    .right {
      float: right;
    }
  }

  .top_title {
    text-align: center;
    font-size: 48px;
    font-weight: 500;
  }

  .top_title.text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;
    color: #333333;

    span {
      width: 33.33%;
    }
  }

  .table {
    width: 100%;
    margin-top: 20px;

    .table_left {
      display: inline-block;
      width: 40%;
    }

    .table_right {
      display: inline-block;
      width: 60%;
    }
  }
}

</style>

<style lang="scss">
.list {
  td.status {
    padding: 0;
    font-size: 17px;
    .cell {
      height: 100%;
      padding: 0;
    }

    .status_box {
      .status_item {
        height: 100%;
        float: left;
        border: 1px solid #41535d;
        padding: 12px;
        border-top-width: 0;
        border-bottom-width: 0;
        &:nth-child(odd) {
          border-right-width: 0;
        }

        &:nth-child(2) {
          border-left-width: 0;
        }

        &:first-child {
          border-right-width: 1px;
          border-left-width: 0;
        }
      }
    }
  }
}
</style>
